export default (context = {}) =>
  fieldLibrary = {
    fieldGroups: {
      bulk: {
        _requiredFields: []
        audienceCreative:
          name: 'Experience Settings'
          description: ''
          fieldKeys: ['primary_type', 'types']
        advancedCreativeSettings:
          name: 'Advanced Experience Settings'
          description: ''
          fieldKeys: ['demographics', 'contacts', 'images']
        calendar:
          name: 'Calendar'
          description: ''
          fieldKeys: ['seasons', 'blockout_dates']
        sponsorExperience:
          name: 'Sponsor Experience'
          description: ''
          fieldKeys: ['sponsor_set', `/* 'cancelation_policy',*/` 'special_terms', 'preferred_brand_categories', 'sold_out']
      }
      advancedSettings: {
        _requiredFields: []
        audienceCreative:
          name: 'Audience Experience'
          description: ''
          fieldKeys: ['host', 'title_pattern', 'contacts', 'demographics']
        sponsorExperience:
          name: 'Sponsor Experience'
          description: ''
          fieldKeys: [`/*'cancelation_policy',*/` 'special_terms', 'preferred_brand_categories', 'sold_out', 'sponsor_primary_domains']
        calendar:
          name: 'Calendar'
          description: ''
          fieldKeys: ['seasons', 'blockout_dates']
        inventoryCapacity:
          name: 'Inventory Capacity'
          description: ''
          fieldKeys: ['engagement_capacity']
      }
    }
    fields: {
      title: {
        name: 'Title',
        component: 'text'
        inputProps: {
          placeholder: 'Title of your experience'
        },
        options: {
          instructions: 'Name of your experience or event',
          why: 'Help sponsors understand what your audience will be there for'
          examples: [
            'Coworking Happy Hour'
            'Friday Night Family Movie'
            'Concert at the Park'
            'Coachella'
            'Students Living in a Dorm'
          ]
        }
      },
      title_pattern: {
        name: 'Title Pattern',
        component: 'title-pattern'
        inputProps: {
          placeholder: 'E.g.: {{title}} - {{city}}, {{state}}'
        },
        options: {
          instructions: 'Configure how your listings will be titled',
        }
      },
      primary_type: {
        name: 'Experience Types'
        component: 'select'
        inputProps: {
          placeholder: 'Search...'
        }
        options: {
          instructions: 'Tell sponsors how you would categorize this experience'
        }
      }
      types: {
        name: 'Experience Types' # overriden in runtime
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 4
        }
        options: {
          instructions: 'Tell sponsors how you would categorize this experience'
        }
      }
      audience_tags: {
        name: 'Audience Types'
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 3
        }
        options: {
          instructions: 'Tell sponsors about the kind of people who will attending'
        }
      }
      activity_tags: {
        name: 'Activity Types'
        component: 'tags'
        inputProps: {
          placeholder: 'Search...'
          limit: 3
        }
        options: {
          instructions: 'Tell sponsors about the activities that attendees will engage in'
        }
      }
      pitch: {
        name: 'Pitch'
        component: 'editor'
        inputProps: {
          placeholder: 'Introduce the experience. What the audience does. Benefits of partnering.'
        }
        options: {
          instructions: 'Brief elevator pitch to help sponsors understand the opportunity'
          why: 'Key points that encourage a sponsor to connect with you.'
        }
      }
      images: {
        name: 'Photos'
        component: 'media'
        options: {
          instructions: 'Upload pictures showing what this experience is all about'
          why: '16:9 aspect size ratio with high resolution shows up best'
          tips: ["acceptable formats are:", "jpg", "png", "gif"]
        }
      }
      sponsor_set: {
        name: 'Brand Partners'
        component: 'brand-select'
        options: {
          instructions: 'List past or current brands you have partnered with so a sponsor is confident that you know how to do this!'
          tips: ["List as many high-quality partners as you can"]
        }
      }
      sponsor_primary_domains: {
        name: 'Sponsor Primary Domains'
        component: 'sponsor-primary-domains'
        options: {
          instructions: 'Mark the brands you want your listing to show (if none are marke, all of them will be visible)'
        }
      }
      catex: {
        name: 'Categories'
        component: 'catex-select'
        options: {
          hideName: true
        }
      }
      host: {
        name: 'Host'
        component: 'text'
        inputProps: {
          placeholder: 'Name of Host...'
        }
        options: {
          instructions: 'Specify who is hosting this experience'
          why: 'The host may be different than the organization, team or venue'
        }
      }
      contacts: {
        name: 'Contact Information'
        component: 'contact-set'
        options: {
          instructions: 'Key people that help make sure everything goes smoothly'
        }
      }
      demographics: {
        name: 'Demographics'
        component: 'demographics'
        options: {
          instructions: 'Let sponsors know an approximate demographic breakdown they will be reaching.'
          tips: [
            'You can estimate the percentage if you don\'t know it exactly'
          ]
        }
      }
      special_terms: {
        name: 'Special Terms'
        component: 'textarea'
        inputProps: {
          placeholder: 'Additional terms a sponsor should know about'
        }
        options: {
          instructions: 'Specify specific restriction, additional terms or conditions'
          why: 'Make sure sponsors know about specific considerations or expectation you may have, if any'
        }
      }
      cancelation_policy: {
        name: 'Cancellation Policy'
        component: 'cancellation-policy'
        options: {
          instructions: 'Set your preferred cancellation policy.'
        }
      }
      preferred_brand_categories: {
        name: 'Preferred Brand Categories'
        component: 'tags'
        inputProps: {
          placeholder: 'Tags'
        }
        options: {
          instructions: 'List any brand categories you feel would be a great fit for the audience'
          why: 'Helps Recess prioritize the sponsors in these categories'
        }
      }
      sold_out: {
        name: 'Sold Out'
        component: 'switch'
        inputProps: {
          items: [
            {
              key: 'sold_out'
              activeLabel: 'Sold Out'
              inactiveLabel: 'Not Sold Out'
            }
          ]
        }
        options: {
          instructions: 'Let sponsors know if this experience is temporarily sold out or otherwise unavailable'
          why: 'Sold out experiences wont be bookable'
        }
      }
      storage_capacity: {
        name: 'Storage Capacity'
        component: 'text-grid'
        inputProps: {
          cols: 2
          items: [
            {
              key: 'cold_storage_count'
              label: 'Cold Storage Capacity'
              description: '# of items available to be stored in cold storage'
              placeholder: 'ex: # of 12oz cans'
            }
            {
              key: 'frozen_storage_capacity'
              label: 'Frozen Storage Capacity'
              description: '# of items available to be stored in frozen storage'
              placeholder: 'ex: # of ice cream bars'
            }
          ]
        }
        options: {
          instructions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
          why: 'Why is this important?'
        }
      }
      seasons: {
        name: 'Seasonal'
        component: 'seasons'
        options: {
          instructions: 'Setup seasons for when your audience is available'
          why: 'Repeating events will not be availble in the off-season'
        }
      }
      blockout_dates: {
        name: 'Blockout Dates'
        component: 'blockout-dates'
        options: {
          instructions: 'Specify dates when your audience is not available to engage with sponsorships'
        }
      }
      engagement_capacity: {
        name: 'Inventory Capacity'
        component: 'inventory-capacity'
        options: {
          hideName: true
        }
      }
    }
  }

  library = JSON.parse(JSON.stringify(fieldLibrary))

  for key, field of library.fields
    field.inputProps ||= context.inputProps?[key] || {}
    field.inputProps?.options ||= context.options?[key]
    field.options.required = key in (context._requiredFields || [])

  library
